import React from 'react';

export default function Footer() {
  return (
    <footer>
      <a
        className='footer-link'
        href='https://github.com/Elena-Stoyanova'
        target='_blank'
        rel='noreferrer noopener'
      >
        <p className='footer-name' id='name'>
          Made by Elena Stoyanova
        </p>
      </a>
    </footer>
  );
}
